import styled from "styled-components";
import {
  getBorderColorFromTheme,
  getColorFromTheme,
  getHoverColorFromTheme,
  getTextColorFromTheme,
} from "../../helper/functions";
import { theme } from "../../theme";
import { ButtonSeverity } from "../../types/types";

export const StyledButton = styled.button<{
  active: boolean;
  severity: ButtonSeverity;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  background-color: ${({ active, severity }) =>
    getColorFromTheme(active, severity)};
  color: ${({ active, severity }) => getTextColorFromTheme(active, severity)};
  padding: 10px 20px;
  border: 2px solid
    ${({ active, severity }) => getBorderColorFromTheme(active, severity)};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  max-height: 44px;
  min-height: 44px;
  svg {
    margin-right: 5px;
    width: 20px;
    height: 20px;
    color: ${({ active, severity }) => getTextColorFromTheme(active, severity)};
  }
  &:hover {
    background-color: ${({ active, severity }) =>
      getHoverColorFromTheme(active, severity)};
    color: ${theme.backgroundColor.primaryWhite};
    transition: all 0.2s ease-in-out;
    svg {
      color: ${theme.backgroundColor.primaryWhite};
      transition: all 0.2s ease-in-out;
    }
  }
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;
